/**
 * Operating Days Config Component
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Settings } from "lucide-react";

const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const OperatingDaysConfig = ({ operatingDays, onToggle }) => {
  return (
    <Card className="bg-blue-50 border-2 border-blue-200">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg text-blue-800 flex items-center gap-2">
          <Settings className="w-5 h-5" />
          Operating Days Configuration
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-blue-600 mb-3">
          Select which days your facility operates. This affects attendance calculations.
        </p>
        <div className="flex flex-wrap gap-4">
          {dayNames.map((day, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Checkbox
                id={`day-${index}`}
                checked={operatingDays[index]}
                onCheckedChange={() => onToggle(index)}
              />
              <Label htmlFor={`day-${index}`} className="text-blue-800">{day}</Label>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default OperatingDaysConfig;
